import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"



/** 有图标的时候需要大的间距样式 */

export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenu',
  props: {
  menuInfo: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;

const hasIconBigger = '14px';
/** 没有图标的时候需要小的间距样式 */
const noIconSmall = '7px';


const handleChildPath = (childPath: string) => {
  return `${props.menuInfo.path}/${childPath}`.replace(/\/+/g, '/');
};

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_SubMenu = _resolveComponent("SubMenu", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (_openBlock(), _createBlock(_component_a_sub_menu, {
    key: __props.menuInfo?.meta?.link || __props.menuInfo.fullPath || __props.menuInfo.id
  }, {
    icon: _withCtx(() => [
      (__props.menuInfo.meta?.icon)
        ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            size: __props.menuInfo.meta?.icon === '#' ? noIconSmall : hasIconBigger,
            icon: __props.menuInfo.meta?.icon,
            "open-key": __props.menuInfo.id
          }, null, 8, ["size", "icon", "open-key"]))
        : _createCommentVNode("", true)
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.menuInfo.meta?.title), 1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuInfo.children, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item?.meta?.link || item.fullPath || item.id
        }, [
          (!item?.children?.length)
            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                key: item?.meta?.link || item.fullPath || item.id
              }, {
                icon: _withCtx(() => [
                  (item.meta?.icon)
                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 0,
                        size: item.meta?.icon === '#' ? noIconSmall : hasIconBigger,
                        icon: item.meta?.icon,
                        "open-key": item.id
                      }, null, 8, ["size", "icon", "open-key"]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(item.meta?.title), 1)
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(_component_SubMenu, {
                key: 1,
                "menu-info": item
              }, null, 8, ["menu-info"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}
}

})